<div class="container-fluid">
  <div class="row review-exchange-details">
    <div class="top-row-text">
      <h3>{{ screenTitle }}</h3>
      <div class="review-exchange-text">{{ screenSubTitle }}</div>
      <div class="back-and-edit" (click)="goBack()">
        <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
      </div>
      <div class="divider"></div>
    </div>

    <ng-container *ngIf="showBanner">
      <div>
        <invd-fm-message-alerts
          *ngFor="let messageInfo of warningMessages; trackBy: trackByIdentity"
          [messageTitle]="messageInfo.title"
          [messageBody]="messageInfo.message"
          [messageType]="messageInfo.type"
        ></invd-fm-message-alerts>
      </div>
    </ng-container>

    <div class="bond-received">
      <h3>Bonds to be Delivered to Fannie Mae</h3>
      <div class="table-responsive review-and-commit-table--overflow">
        <table class="table">
          <thead>
            <tr>
              <ng-container *ngIf="displayRecomColumn">
                <th>RECOM</th>
              </ng-container>
              <th>CLASS/POOL</th>
              <th>CUSIP</th>
              <th>CLEARING INSTITUTION</th>
              <th>ORIGINAL BALANCE EXCHANGED</th>
              <th>CURRENT BALANCE EXCHANGED</th>
            </tr>
          </thead>
          <tbody
            *ngFor="
              let netExchangeView of rcrResponseData.netExchangeViews;
              trackBy: trackByIdentity
            "
          >
            <tr
              *ngFor="
                let bond of netExchangeView.netToFNMA;
                let index = index;
                trackBy: trackByIdentity
              "
            >
              <ng-container *ngIf="displayRecomColumn">
                <td>{{ bond?.recomNumbers }}</td>
              </ng-container>
              <td>{{ bond?.bondClass }}</td>
              <td>{{ bond?.cusip }}</td>
              <td>{{ bond?.clearingInstitution }}</td>
              <td>{{ bond?.origFace | currency: 'USD' : 'symbol' : '1.0-0' }}</td>
              <td>{{ bond?.currentFace | currency: 'USD' : 'symbol' : '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="bond-received">
      <h3>Bonds to be Received from Fannie Mae</h3>
      <div class="table-responsive review-and-commit-table--overflow">
        <table class="table">
          <thead>
            <tr>
              <ng-container *ngIf="displayRecomColumn">
                <th>RECOM</th>
              </ng-container>
              <th>CLASS/POOL</th>
              <th>CUSIP</th>
              <th>CLEARING INSTITUTION</th>
              <th>ORIGINAL BALANCE EXCHANGED</th>
              <th>CURRENT BALANCE EXCHANGED</th>
            </tr>
          </thead>
          <tbody
            *ngFor="
              let netExchangeView of rcrResponseData.netExchangeViews;
              trackBy: trackByIdentity
            "
          >
            <tr
              *ngFor="
                let bond of netExchangeView.netToDealer;
                let index = index;
                trackBy: trackByIdentity
              "
            >
              <ng-container *ngIf="displayRecomColumn">
                <td>{{ bond?.recomNumbers }}</td>
              </ng-container>
              <td>{{ bond?.bondClass }}</td>
              <td>{{ bond?.cusip }}</td>
              <td>{{ bond?.clearingInstitution }}</td>
              <td>{{ bond?.origFace | currency: 'USD' : 'symbol' : '1.0-0' }}</td>
              <td>{{ bond?.currentFace | currency: 'USD' : 'symbol' : '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ng-container *ngIf="!isAtSettlementFlow">
      <div class="col-lg-4 offset-lg-8 total-fees">
        <ng-container *ngIf="rcrResponseData.feeCurrentFace === 0">
          <div class="total-fees-fee-name">
            Current Face:
            <span class="total-fees__fee-value">{{
              rcrResponseData.feeCurrentFaceNotional | currency: 'USD' : 'symbol' : '1.2-2'
            }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="rcrResponseData.feeCurrentFace !== 0">
          <div class="total-fees-fee-name">
            Current Face:
            <span class="total-fees__fee-value">{{
              rcrResponseData.feeCurrentFace | currency: 'USD' : 'symbol' : '1.2-2'
            }}</span>
          </div>
        </ng-container>
        <div class="total-fees-fee-name fee-block">
          <span class="total-fees__fee-value highlight"
            >Fee: {{ displayedFeeTicks | number: '1.2-2' }}/32</span
          >
        </div>

        <ng-container *ngIf="feeComment">
          <div class="comment-name" style="font-weight: bolder">
            Comment: <span style="font-weight: bold">{{ feeComment }}</span>
          </div>
        </ng-container>

        <div class="total-fees-fee-name">
          Total Fee:
          <span class="total-fees__fee-value">{{
            displayedFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
          }}</span>
        </div>
        <div class="total-fees-fee-name">
          Settlement Date:
          <span class="total-fees__fee-value">{{
            rcrResponseData.exchangeSettlementDate | date: 'MM/dd/yyyy' : 'America/New_York'
          }}</span>
        </div>
        <div>
          <div class="fee-schedule float" *ngIf="isInternalUsr" (click)="showChangeFee()">
            Change Fee
          </div>
          <div class="fee-schedule disable float" *ngIf="!isInternalUsr">Change Fee</div>
          <div class="fee-schedule seperator float">|</div>
          <div class="fee-schedule float" (click)="getFeeSchedule()">See Fee Schedule</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="fee-shedule-model-window" *ngIf="showFeeSheduleModelWindow">
  <div class="panel panel-default fadeInUpBig">
    <button
      type="button"
      class="close float-end"
      aria-label="Close"
      (click)="closeFeeSheduleModelWindow()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-body">
      <invd-fee-schedule></invd-fee-schedule>
      <div class="fee-schedule" (click)="closeFeeSheduleModelWindow()">GOT IT</div>
    </div>
  </div>
</div>

<div class="fee-shedule-model-window" *ngIf="showChangeFeeModelWindow">
  <div class="panel panel-default">
    <button type="button" class="close float-end" aria-label="Close" (click)="hideChangeFee()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-body">
      <h4>Change Fee</h4>
      <form class="fee-change-form">
        <div class="col-md-6">
          <div class="form-group">
            <div
              class="btn-group fee-change-select"
              (click)="$event.preventDefault()"
              (mouseleave)="closeChangeFeeDropdown()"
            >
              <button
                class="btn btn-secondary dropdown-toggle request-exchange-select__button"
                type="button"
                id="dropdownMenuSelExchangeType"
                (click)="toggleChangeFeeDropdown()"
                [attr.aria-expanded]="isChangeFeeDropdownOpen"
              >
                {{ selectedChangeFeesItem ? selectedChangeFeesItem.label : 'Select Fee' }}
                <span class="caret"></span>
              </button>
              <ul
                class="dropdown-menu changeFeesDropDownList"
                [ngClass]="{ show: isChangeFeeDropdownOpen }"
              >
                <li *ngFor="let dropdownItem of changeFeesDropDownList; trackBy: trackByIdentity">
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="changeFeesDropDownListClick(dropdownItem)"
                  >
                    {{ dropdownItem.label }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="selectedChangeFeesItem?.id === 0">
          <div class="form-group">
            <span class="currency-addon">$</span>
            <input
              type="number"
              invdWholeNumberOnly
              class="form-control currency"
              [(ngModel)]="manualFeesAmount"
              name="manualFeesAmount"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <textarea
              invdTextLengthLimitation
              (change)="allowedText()"
              class="form-control fee-change-textarea"
              name="changeFeesComments"
              [(ngModel)]="tempFeeCommentStr"
              placeholder="Comments (optional): 500 characters"
            ></textarea>
          </div>
        </div>
        <div class="col-md-12 fee-change-button-row">
          <div class="fee-schedule btn cancelButton" (click)="hideChangeFee('cancel')">Cancel</div>
          <div
            class="fee-schedule btn saveButton {{
              selectedChangeFeesItem
                ? selectedChangeFeesItem?.id === 0
                  ? manualFeesAmount != null
                    ? ''
                    : 'disabled'
                  : ''
                : 'disabled'
            }}"
            (click)="hideChangeFee('save')"
          >
            Save
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="fee-shedule-model-window" *ngIf="showCancelExchangeConfirmation">
  <div class="panel panel-default">
    <button
      type="button"
      *ngIf="isCancelConfirmation"
      class="close float-end"
      aria-label="Close"
      (click)="cancelExchange(false)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <button
      type="button"
      *ngIf="!isCancelConfirmation"
      class="close float-end"
      aria-label="Close"
      (click)="closeAndBackToRCRexchange()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-body">
      <invd-cancel-exchange-confirmation
        [isCancelConfirmation]="true"
        [dealNumber]="dealNumber"
        *ngIf="isCancelConfirmation"
      ></invd-cancel-exchange-confirmation>
      <invd-cancel-exchange-confirmation
        [isCancelConfirmation]="false"
        [dealNumber]="dealNumber"
        *ngIf="!isCancelConfirmation"
      ></invd-cancel-exchange-confirmation>
      <button
        class="button fm-tertiary-button"
        *ngIf="isCancelConfirmation"
        (click)="cancelExchange(false)"
      >
        NO
      </button>
      <button
        class="button fm-primary-button"
        *ngIf="isCancelConfirmation"
        (click)="closeAndBackToRCRexchange()"
      >
        YES
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="displayPricingRule">
  <div class="pricingrule-model-window">
    <div class="panel panel-default">
      <button
        type="button"
        *ngIf="isCancelConfirmation"
        class="close float-end"
        aria-label="Close"
        (click)="displayPricingRule = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <div class="panel-body mega-cancel-confirmation-model">
        <h4>Please review pricing rules</h4>

        <p>
          This deal was issued before January 1, 2007. <br />Please review the Prospectus Supplement
          to ensure <br />accurate pricing.
        </p>
        <br />
        <p>To view this deal’s Prospectus Suppplement</p>
        <a href="{{ prospectSupplURL }}" target="_blank" class="cancelButton fee-schedule"
          >CLICK HERE</a
        >
        <br /><br />
        <div class="col-12 col-sm-12 col-lg-12">
          <button class="button fm-primary-button" (click)="displayPricingRule = false">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showBannerExitIconNavigationPopup">
  <div class="pricingrule-model-window">
    <div class="panel panel-default fadeInUpBig">
      <button
        type="button"
        class="close float-end"
        aria-label="Close"
        (click)="showBannerExitIconNavigationPopup = !showBannerExitIconNavigationPopup"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="panel-body">
        <h4 class="bannerExitIconNavPopupTextAlign">
          You are about to stop acting on behalf of this user
        </h4>
        <br />
        <p class="bannerExitIconNavPopupTextAlign">
          Please be advised by doing so, any work you have done to this point for the user that has
          not already been saved will be lost.
        </p>
        <br />
        <div class="bannerExitIconNavPopupButtonAlign">
          <button
            class="button fm-tertiary-button"
            (click)="showBannerExitIconNavigationPopup = !showBannerExitIconNavigationPopup"
          >
            NEVERMIND
          </button>
          <button class="button fm-primary-button" (click)="goToRCRRequestExchangePage()">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<invd-rcr-exchange-sticky-footer [footerContent]="stickFooterComponents">
</invd-rcr-exchange-sticky-footer>
